import { toast } from "react-toastify";
import axiosClient from "api/axiosClient";

export const getSubscriptionInfo = async () => {
  try {
    const response = await axiosClient.get("api/subscriptions/info/me");
    return response.data;
  } catch (error) {
    console.error("Error getting subscription info:", error);
    // toast.error("Failed to get subscription info. Please try again.");
    throw error;
  }
};
